export type TopicView = 'list' | 'grid'

interface Props {
  view: TopicView
  onChange: (view: TopicView) => void
}

// List/Grid switcher, styled after the Scoreboard viewMode toggle.
export default function ViewToggle({ view, onChange }: Props) {
  const options: { key: TopicView; label: string; icon: JSX.Element }[] = [
    {
      key: 'list',
      label: 'List',
      icon: (
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      ),
    },
    {
      key: 'grid',
      label: 'Grid',
      icon: (
        <svg className="w-3.5 h-3.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M4 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1V5zM14 5a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1V5zM4 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1H5a1 1 0 01-1-1v-4zM14 15a1 1 0 011-1h4a1 1 0 011 1v4a1 1 0 01-1 1h-4a1 1 0 01-1-1v-4z" />
        </svg>
      ),
    },
  ]

  return (
    <div className="inline-flex rounded-lg border border-stone/30 overflow-hidden flex-shrink-0">
      {options.map(opt => (
        <button
          key={opt.key}
          type="button"
          onClick={() => onChange(opt.key)}
          aria-pressed={view === opt.key}
          className={`px-3 py-1.5 text-xs font-semibold transition-colors flex items-center gap-1.5 ${
            view === opt.key
              ? 'bg-[#351E1D] text-white'
              : 'bg-white text-text-primary hover:bg-stone/10'
          }`}
          title={`${opt.label} view`}
        >
          {opt.icon}
          {opt.label}
        </button>
      ))}
    </div>
  )
}
